<template>
  <el-dialog :title="dialogTitle"
             :visible.sync="dialogVisible"
             width="680px"
             append-to-body
             @closed="handleDialogClosed">
    <el-form ref="dialogForm"
             :model="dialogForm"
             :rules="dialogRules"
             label-width="150px">
      <el-form-item label="知识库名称"
                    prop="name">
        <el-input v-model="dialogForm.name"
                  placeholder="请输入知识库名称"
                  maxlength="255"
                  clearable />
      </el-form-item>
      <el-form-item label="是否通用"
                    prop="is_common">
        <el-radio-group v-model="dialogForm.is_common"
                        :disabled="isDialogEditLocked"
                        @change="handleDialogIsCommonChange">
          <el-radio :label="1">通用</el-radio>
          <el-radio :label="0">专用</el-radio>
        </el-radio-group>
        <div class="training-knowledge-form-dialog__tips">通用知识库适用于所有用户，专用知识库仅适用于特定客户</div>
      </el-form-item>
      <el-form-item v-if="Number(dialogForm.is_common) === 0"
                    label="所属客户"
                    prop="customerid">
        <remote-select class="width-max"
                       clearable
                       id-key="number"
                       label-key="name"
                       value-key="id"
                       placeholder="请选择客户"
                       v-model="dialogForm.customerid"
                       :disabled="isDialogEditLocked"
                       :query-request="getCustomerTable"
                       :find-request="getCustomerDetail" />
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button @click="closeDialog">取消</el-button>
      <el-button type="primary"
                 :loading="saving"
                 @click="saveTrainingKnowledge">保存</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { consts, isKnowledgeDialogEditLocked } from '@views/training/training-knowledge.constants'

const DEFAULT_FORM = () => ({
  name: '',
  is_common: 1,
  customerid: null,
})

export default {
  name: 'TrainingKnowledgeFormDialog',
  data () {
    return {
      consts,
      dialogVisible: false,
      dialogTitle: '',
      dialogId: 0,
      dialogStatus: consts.STATUS_NEW,
      saving: false,
      dialogForm: DEFAULT_FORM(),
      dialogRules: {
        name: [
          { required: true, message: '请输入知识库名称', trigger: 'blur' },
        ],
        is_common: [
          { required: true, message: '请选择是否通用', trigger: 'change' },
        ],
        customerid: [
          {
            validator: (rule, value, callback) => {
              if (Number(this.dialogForm.is_common) === 0 && !value) {
                callback(new Error('请选择客户'))
                return
              }
              callback()
            },
            trigger: 'change',
          },
        ],
      },
    }
  },
  computed: {
    isDialogEditLocked () {
      return isKnowledgeDialogEditLocked(this.dialogId, this.dialogStatus)
    },
  },
  methods: {
    ...request.map([
      'getCustomerTable',
      'getCustomerDetail',
      'getTrainingKnowledgeDetail',
    ]),
    openCreate (prefill = {}) {
      this.dialogTitle = '新增知识库'
      this.dialogId = 0
      this.dialogStatus = consts.STATUS_NEW
      this.resetDialogForm(prefill)
      this.dialogVisible = true
    },
    openEdit (id) {
      request.loading('getTrainingKnowledgeDetail', { id }).then(({ data }) => {
        this.dialogTitle = '修改知识库'
        this.dialogId = Number(id)
        this.dialogStatus = Number(data.status) || consts.STATUS_NEW
        this.dialogForm = {
          name: data.name,
          is_common: Number(data.is_common),
          customerid: data.customerid ? String(data.customerid) : null,
        }
        this.dialogVisible = true
        this.handleDialogIsCommonChange(this.dialogForm.is_common)
      })
    },
    resetDialogForm (prefill = {}) {
      this.dialogForm = Object.assign(DEFAULT_FORM(), {
        is_common: prefill.is_common != null ? Number(prefill.is_common) : 1,
        customerid: prefill.customerid ? String(prefill.customerid) : null,
      })
      this.$nextTick(() => {
        if (this.$refs.dialogForm) {
          this.$refs.dialogForm.clearValidate()
        }
      })
    },
    closeDialog () {
      this.dialogVisible = false
    },
    handleDialogClosed () {
      this.dialogId = 0
      this.dialogStatus = consts.STATUS_NEW
      this.saving = false
      this.resetDialogForm()
    },
    handleDialogIsCommonChange (value) {
      if (this.isDialogEditLocked) {
        return
      }
      if (Number(value) === 1) {
        this.dialogForm.customerid = null
      }
      this.$nextTick(() => {
        if (this.$refs.dialogForm) {
          this.$refs.dialogForm.clearValidate('customerid')
        }
      })
    },
    getDialogSubmitData () {
      const isCommon = Number(this.dialogForm.is_common)
      return {
        id: this.dialogId,
        name: this.dialogForm.name,
        is_common: isCommon,
        customerid: isCommon === 1 ? 0 : this.dialogForm.customerid,
      }
    },
    saveTrainingKnowledge () {
      this.$refs.dialogForm.validate((valid) => {
        if (!valid) {
          return
        }
        const apiName = this.dialogId ? 'updateTrainingKnowledge' : 'createTrainingKnowledge'
        this.saving = true
        request.loading(apiName, this.getDialogSubmitData()).then(({ data }) => {
          this.$message.success('保存成功')
          const createdId = this.dialogId || (data && (data.id || data))
          const payload = Object.assign({}, this.getDialogSubmitData(), {
            id: createdId,
          })
          this.$emit('success', payload)
          this.closeDialog()
        }).finally(() => {
          this.saving = false
        })
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.training-knowledge-form-dialog__tips {
  color: #8492a6;
  font-size: 12px;
  line-height: 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/training/components/TrainingKnowledgeFormDialog.vue